import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FileText } from "lucide-react";
import { api } from "../../lib/api";

export default function Facture() {
  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    api.get("/client/invoices")
      .then(({ data }) => setInvoices(data || []))
      .catch(() => setInvoices([]));
  }, []);

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl space-y-6">
      <div>
        <h1 className="mt-2 font-sans text-3xl font-medium text-ink sm:text-4xl">Facture</h1>
        <p className="mt-2 font-light text-ink-soft">Retrouve ici tes factures, téléchargeables en un clic.</p>
      </div>

      {invoices === null && <p className="text-sm text-ink-muted">Chargement…</p>}

      {invoices !== null && invoices.length === 0 && (
        <p data-testid="invoice-empty" className="rounded-2xl border border-dashed border-bordeaux-border bg-bordeaux-tint/30 px-5 py-12 text-center text-sm font-light italic text-ink-muted">
          Aucune facture disponible pour le moment.
        </p>
      )}

      {invoices !== null && invoices.length > 0 && (
        <div className="space-y-3">
          {invoices.map((inv) => (
            <div key={inv.id} data-testid={`invoice-file-${inv.id}`} className="flex items-center gap-4 rounded-2xl border border-line bg-white p-5 shadow-card">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-bordeaux-tint text-bordeaux">
                <FileText size={20} />
              </span>
              <a href={inv.url} target="_blank" rel="noreferrer" download={inv.name} data-testid={`invoice-download-${inv.id}`} className="flex-1 truncate text-sm font-medium text-bordeaux underline underline-offset-4">
                {inv.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
}
